import {
  useState,
  useEffect,
  CSSProperties,
  useRef,
  useMemo,
  useCallback,
  SetStateAction,
  cache,
  forwardRef,
  useImperativeHandle,
  use,
} from "react";
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "../../../redux/store";
import {
  groupFnQuery,
  newQuery,
  resultQuery,
  setQuery,
  setQuerySubType,
  setResultHeaders,
  setupQuery,
  setAxesWithAllSelected,
  setResults,
  historyQuery,
  setLoadQueryMode,
  selectCurrentTab,
  changeTab,
  addNewTab,
  setIsLoadingSavedQueries,
  setCurrUpdatingTabIndex,
  resetQuerySlice,
  setIsSavedQueryLoaded,
  tabsData,
  setLoadQueryIds,
  setIsLoadingQuery,
  setMsrSelections,
  changeTabName,
  resetTabname,
  resetUpdatedNamedsetList,
} from "../../../redux/queryBuilderSlice";
import { AgGridReact } from "ag-grid-react";
import {
  GridApi,
  ColumnState,
  RowClassParams,
  ColumnMovedEvent,
  DragStoppedEvent,
} from "ag-grid-community";
import {
  faArrowRotateLeft,
  faArrowRotateRight,
  faChartLine,
  faExpand,
  faFileExport,
  faFilter,
  faFilterCircleXmark,
  faGlobe,
  faList,
  faRedo,
  faRefresh,
  faRetweet,
  faUndo,
} from "@fortawesome/free-solid-svg-icons";
import { IconButton } from "../../../components/button/IconButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Loading from "../../../components/Loading";
import QueryChart from "./QueryChart";
import { Query, Result } from "../../../interfaces/queryBuilderInterfaces";
import Map from "./Maps";
import { setQueryMode, setLoading } from "../../../redux/queryBuilderSlice";
import {
  arraysEqual,
  checkIsMeasureAttr,
  convertFilterToEnhancedFilterCriteria,
  countMeasureNodes,
  deepEqual,
  hasMatch,
} from "../../../utils/util";
import ExportPopup from "./ExportPopup";
import { useModal } from "../../../components/Modal";
import {
  loadQuery,
  saveGroupId,
  saveQueryId,
  saveQueryIds,
  setSavedQueryName,
  setSaveQueryNameToAll,
  setPendingLegacyQuery,
} from "../../../redux/saveSlice";
import {
  addNewMapQuery,
  getMapResult,
  resetMapSlice,
  selectCurrentMapQuery,
  setMapData,
} from "../../../redux/mapSlice";
import {
  setSelectedCube,
  Cube,
  addNewMetaState,
  resetMetaState,
  getMetadata,
} from "../../../redux/queryMetaSlice";
import { data, useLocation } from "react-router-dom";
import { parseLegacyTipNetQuery } from "../../../utils/legacyTipNetParser";
import ToolTip from "../../../components/ToolTip";
import ConfirmPopup from "../../../components/ConfirmPopup";
import { Button } from "../../../components/button/Button";
import { exportRequest } from "../../../redux/exportSlice";
import { showNotification } from "../../../redux/notificationSlice";
import LoadingOverlay from "../../../components/LoadingOverlay";
import { color } from "html2canvas/dist/types/css/types/color";
import { QueryResultAggregator } from "./QueryResultAggregator";
import TimeSelector from "../../../components/TimeSelector";
import ReviewSelection from "./ReviewSelection";
import ActionDropdown from "../../../components/dropdown/ActionDropdown";

interface QueryResultProps {
  gridRef: React.RefObject<AgGridReact<Result> | null>;
  currentActiveTab: number;
  initialLoading?: boolean;
  setIsInitialLoading: React.Dispatch<SetStateAction<boolean>>;
  setActivePanelTab: React.Dispatch<SetStateAction<"displayFields" | "namedSet">>;
}
export interface MyRefHandle {
  callResetAll: () => void;
  getQueryName: any;
}

const QueryResult = forwardRef<MyRefHandle, QueryResultProps>(
  (
    {
      gridRef,
      currentActiveTab: currentTabIndex,
      initialLoading,
      setIsInitialLoading,
      setActivePanelTab
    },
    ref,
  ) => {
    //const gridRef = useRef<AgGridReact<Result>>(null);
    const chartRef = useRef<HTMLDivElement>(null);
    const dispatch = useDispatch<AppDispatch>();
    // const currentTabIndex = useSelector(
    //   (state: any) => state.queryBuilder.currentTabIndex
    // );

    const [isError, setIsError] = useState(false);

    const selectedCube = useSelector(
      (state: any) => state.meta.metaStates[currentTabIndex].selectedCube,
    );

    const measures = useSelector(
      (state: any) => state.meta.metaStates[currentTabIndex].measures,
    );
    const dimensions = useSelector(
      (state: any) => state.meta.metaStates[currentTabIndex].dimensions,
    );
    const metadataGroup = useSelector(
      (state: any) => state.meta.metaStates[currentTabIndex].metadataGroup,
    );

    const { user = null } = useSelector((state: RootState) => state.user);

    const loadedQueryIds = useSelector(
      (state: any) => state.queryBuilder.loadQueryIds,
    );

    const pendingLegacyQuery = useSelector(
      (state: any) => state.save.pendingLegacyQuery,
    );

    const currTabData = useSelector(selectCurrentTab);

    const mapResults = useSelector(
      (state: any) => state.map.mapQueries[currentTabIndex].result,
    );

    const queryMode = useSelector((state: RootState) => currTabData.queryMode);
    const isLoadingSavedQuery = useSelector(
      (state: RootState) => currTabData.isLoadingQuery,
    );
    const isSavedQueryLoaded = useSelector(
      (state: RootState) => currTabData.isSavedQueryLoaded,
    );
    const queryIds = useSelector((state: any) => state.save.queryIds);

    const querySubType = useSelector(
      (state: RootState) => currTabData.querySubType,
    );
    const [showMap, setShowMap] = useState<boolean>(
      queryMode == "Map" ? true : false,
    );

    const query = useSelector((state: RootState) => currTabData.query);
    const isSourceHistory = useSelector(
      (state: RootState) => currTabData.isSourceHistory,
    );
    const [reorderEvent, setReorderEvent] = useState<{
      fromIndex: number;
      toIndex: number;
    } | null>(null);
    const isLoading = useSelector((state: RootState) => currTabData.loading);
    const currentQueryIndex = useSelector(
      (state: RootState) => currTabData.currentQueryIndex,
    );
    const historyCount = useSelector(
      (state: RootState) => currTabData.historyCount,
    );
    const isLoadQueryMode = useSelector(
      (state: RootState) => currTabData.isLoadQueryMode,
    );

    const [isLoadQuery, setIsLoadQuery] = useState(false);
    const exportQueryFlag = useSelector(
      (state: RootState) => state.export.exportRequestLoading,
    );
    const [isExportQuery, setIsExportQuery] = useState(exportQueryFlag);
    const [savedQueryName, setQueryName] = useState("New Query");
    const tabs = useSelector(tabsData);

    const [resultInfo, setResultInfo] = useState<any>(null);
    const [dataloadInfo, setDataloadInfo] = useState<any>(null);

    const errorMessge = useSelector((state: RootState) => currTabData.error);

    const [showConfirmPopup, setShowConfirmPopup] = useState(false);

    const [confirmPopUp, setConfirmPopUp] = useState({
      title: "",
      message: "",
      confirmAction: (title: string, id: number) => {},
      closeAction: () => {},
      id: 0,
    });

    const isQueryUpdated = useSelector(
      (state: RootState) => currTabData.isQueryUpdated,
    );

    const defaultNewQuery = (isAll: boolean) => {
      const currTab = isAll ? 0 : currentTabIndex;
      if (selectedCube && !isLoadQuery) {
        setIsLoadQuery(true);

        const formData = new FormData();
        formData.append("connection", selectedCube.connection);
        formData.append("cube", selectedCube.name);
        formData.append("catalog", selectedCube.catalog);
        formData.append("schema", selectedCube.schema);
        dispatch(newQuery({ formData, index: currTab })).then((query: any) => {
          dispatch(setupQuery({ payload: query.payload, index: currTab })).then(
            (query: any) => {
              dispatch(
                resultQuery({
                  query: query.payload,
                  queryMode: "Grid",
                  index: currTab,
                }),
              ).then(() => {
                setShowMap(false);
                setShowChart(false);
                dispatchQueryMode("Grid");
                dispatch(
                  setQuerySubType({ type: null, currentTabIndex: currTab }),
                );
                isDefaultQueryRunning.current = false;
              });
              setIsLoadQuery(false);
            },
          );
        });
      }
    };

    const rowHeight = 25;
    const headerHeight = 25;
    const [style, setStyle] = useState<CSSProperties>({
      height: "300px",
      maxWidth: "calc(100% - 25px)",
    });

    const updateHeight = () => {
      const newHeight = window.innerHeight - 380;
      setStyle((prevStyle) => ({ ...prevStyle, height: `${newHeight}px` }));
    };

    useEffect(() => {
      updateHeight();
      window.addEventListener("resize", updateHeight);
      return () => {
        window.removeEventListener("resize", updateHeight);
      };
    }, []);

    const [rowData, setRowData] = useState<any[]>([]);
    const [columnDefs, setColumnDefs] = useState<any[]>([]);
    const [availableOptions, setAvailableOptions] = useState<string[]>([]);
    const [sortedData, setSortedData] = useState<Result[]>();

    const flattenedResults = useSelector(
      (state: RootState) => currTabData.results,
    );

    const countHeaders = (headers: any) => {
      const countChildren = (header: any) => {
        if (header.children && Array.isArray(header.children)) {
          return header.children.reduce((count: any, childHeader: any) => {
            return count + countChildren(childHeader);
          }, 0);
        }
        return 1;
      };

      return headers.reduce((count: any, header: any) => {
        return count + countChildren(header);
      }, 0);
    };

    const getFilterType = (datatype: string) => {
      switch (datatype) {
        case "number":
          return "agNumberColumnFilter";
        case "date":
          return "agDateColumnFilter";
        default:
          return "agSetColumnFilter";
      }
    };

    const createNumericComparator = () => {
      return (valueA: string, valueB: string) => {
        const numA = parseFloat(valueA);
        const numB = parseFloat(valueB);
        if (isNaN(numA) && isNaN(numB)) return 0;
        if (isNaN(numA)) return 1;
        if (isNaN(numB)) return -1;
        return numA - numB;
      };
    };

    useEffect(() => {
      setSortedData([]);
    }, [flattenedResults]);

    const prevTabIndexRef1 = useRef(currentTabIndex);
    const isDefaultQueryRunning = useRef(false);
    useEffect(() => {
      if (isSourceHistory) return;
      const tabIndexChanged = prevTabIndexRef1.current !== currentTabIndex;
      if (tabIndexChanged) {
        prevTabIndexRef1.current = currentTabIndex;
        return;
      }
      if (!flattenedResults) {
        return;
      }
      if (isDefaultQueryRunning.current) {
        isDefaultQueryRunning.current = false;
        return;
      }
      if (queryMode == "Viz" || queryMode == "Grid") {
        dispatch(
          resultQuery({
            query,
            queryMode,
            querySubType,
            index: currentTabIndex,
          }),
        );
      }
    }, [queryMode, querySubType, currentTabIndex]);

    useEffect(() => {
      if (
        flattenedResults &&
        (isLoadQuery ||
          queryMode != "Map" ||
          mapResults?.progress == "Aborted" ||
          mapResults?.progress == "Deferred")
      ) {
        const newRowData = flattenedResults.result.rows;
        let newColumnDefs: any[] = flattenedResults?.result?.headers || [];
        const totalWidth = countHeaders(newColumnDefs) * 210;

        if (dimensions) {
          dimensions.forEach((dim: any) => {
            dim["hierarchies"][0].levels.forEach((level: any) => {
              newColumnDefs = newColumnDefs.map((column: any) => {
                if (column.levelUniqueName === level.uniqueName) {
                  const datatype = level.properties?.["datatype"] || "String";
                  return {
                    ...column,
                    headerTooltip: column?.headerName,
                    tooltipField: column?.field,
                    minWidth: 120,
                    cellClass:
                      column?.levelUniqueName &&
                      hasMatch(column.levelUniqueName, ["Measures"])
                        ? "text-right"
                        : "text-left",
                    filter: getFilterType(datatype),
                    flex: 1,
                    /*filterParams: {
                                        values: (params: any) => {
                                            const uniqueValues = new Set<string>();
                                            for (let i = 0; i < params.api.getDisplayedRowCount(); i++) {
                                                const rowNode = params.api.getDisplayedRowAtIndex(i);
                                                if (rowNode) {
                                                    const value = rowNode.data[column.field];
                                                    if (value !== '|SUM|' && value !== '|AVG|') {
                                                        uniqueValues.add(value);
                                                    }
                                                }
                                            }
                                            params.success(Array.from(uniqueValues));
                                        },
                                    }*/
                  };
                }
                return column;
              });
            });
          });
        }

        if (measures) {
          measures.forEach((measure: any) => {
            newColumnDefs = newColumnDefs.map((column: any) => {
              const newColumn = {
                ...column,
                flex: 1,
                headerTooltip: column?.headerName,
                tooltipField: column?.field,
                minWidth: 120,
                cellClass:
                  column?.levelUniqueName &&
                  hasMatch(column.levelUniqueName, ["Measures"])
                    ? "text-right"
                    : "text-left",
              };

              const isMeasureMatch = newColumn.children
                ? newColumn.children.some(
                    (child: any) => child.headerName === measure.caption,
                  )
                : newColumn.headerName === measure.caption;

              if (isMeasureMatch) {
                if (newColumn.children) {
                  newColumn.children = newColumn.children.map((child: any) => {
                    const updatedChild = {
                      ...child,
                      comparator: createNumericComparator(),
                      sortable: queryMode === "Map" ? false : true,
                      flex: 1,
                      headerTooltip: child?.headerName,
                      tooltipField: child?.field,
                      minWidth: 120,
                      cellClass:
                        child?.levelUniqueName &&
                        hasMatch(child.levelUniqueName, ["Measures"])
                          ? "text-right"
                          : "text-left",
                    };

                    // Check if the child has its own children and is an array
                    if (child.children && Array.isArray(child.children)) {
                      // Map over nested children and return the updated array
                      updatedChild.children = child.children.map(
                        (nestedChild: any) => {
                          return {
                            ...nestedChild,
                            headerTooltip: nestedChild?.headerName,
                            tooltipField: nestedChild?.field,
                            flex: 1,
                            minWidth: 120,
                            cellClass:
                              nestedChild?.levelUniqueName &&
                              hasMatch(nestedChild.levelUniqueName, [
                                "Measures",
                              ])
                                ? "text-right"
                                : "text-left",
                          };
                        },
                      );
                    }

                    return updatedChild; // Return the updated child object
                  });
                } else {
                  return {
                    ...newColumn,
                    headerTooltip: newColumn?.headerName,
                    tooltipField: newColumn?.field,
                    comparator: createNumericComparator(),
                    sortable: queryMode === "Map" ? false : true,
                    flex: 1,
                    minWidth: 120,
                    cellClass:
                      newColumn?.levelUniqueName &&
                      hasMatch(newColumn.levelUniqueName, ["Measures"])
                        ? "text-right"
                        : "text-left",
                  };
                }
              }
              return newColumn;
            });
          });
        }
        // Apply sum/avg rules recursively to headers
        newColumnDefs = newColumnDefs.map((header: any, index: any) => {
          return applyRulesRecursively(header, index, newColumnDefs);
        });
        setRowData(newRowData);
        setColumnDefs(newColumnDefs);
        setAvailableOptions(flattenedResults.availableOptions);
        setStyle((prevStyle) => ({ ...prevStyle, width: totalWidth }));
        setSortedData(newRowData);
        // setResultInfo(
        //   `Showing : ${flattenedResults.result.queryRuntime.rows} Row(s), ${flattenedResults.result.queryRuntime.cols} Column(s)`
        // );
      }
    }, [dispatch, flattenedResults, queryMode]);

    useEffect(() => {
      if (errorMessge) {
        setRowData([]);
      }
    }, [errorMessge]);

    const dispatchQueryMode = async (
      mode: string,
      index: number | null = null,
    ) => {
      dispatch(
        setQueryMode({ type: mode, currentTabIndex: index || currentTabIndex }),
      );
    };
    useEffect(() => {
      if (queryMode == "Viz") {
        setChartType(querySubType);
        setMapType(null);
      } else if (queryMode == "Map") {
        setChartType(null);
        setMapType(querySubType);
      } else {
        setMapType(null);
        setChartType(null);
      }
    }, [querySubType]);

    const [showChart, setShowChart] = useState<boolean>(
      queryMode == "Viz" ? true : false,
    );

    const canViewMap = () => {
      if (
        flattenedResults &&
        flattenedResults.query &&
        flattenedResults.query.axes &&
        dimensions
      ) {
        const enhancedFilterCriteria =
          flattenedResults.query.enhancedFilterCriteria;

        const hasNamedSetFilter = Object.values(enhancedFilterCriteria || {}).some(
          (filterBlocks: any) => {
            if (!Array.isArray(filterBlocks)) return false;
            return filterBlocks.some((block: any) => {
              if (!Array.isArray(block?.criteria)) return false;
              return block.criteria.some((criteria: any) => {
                if (!Array.isArray(criteria?.values)) return false;
                return criteria.values.some((value: any) => value?.namedSet === true);
              });
            });
          },
        );

        if (hasNamedSetFilter) {
          return false;
        }

        const axes = flattenedResults.query.axes;
        const allAxes = [...axes.ROWS, ...axes.COLUMNS];
        const isMapEnabled = allAxes.some((axis: any) => {
          return dimensions.some((dim: any) => {
            return dim.hierarchies[0].levels.some((level: any) => {
              return (
                level.uniqueName === axis &&
                level.properties["map.enable"] === "Y"
              );
            });
          });
        });
        return isMapEnabled;
      }
      return false;
    };
    const showButton = () => {
      return (
        flattenedResults &&
        flattenedResults.result &&
        flattenedResults.result.rows.length > 0
      );
    };

    const [columnState, setColumnState] = useState<ColumnState[]>([]);

    const onGridReady = (params: { api: GridApi }) => {
      if (gridRef.current) {
        gridRef.current.api = params.api;
      }
      const initialColumnState = params.api.getColumnState();
      setColumnState(initialColumnState);
    };

    const getLastChild = (header: any, column: any) => {
      if (column.colId == header.field) {
        return header;
      }
      if (header.children && header.children.length > 0) {
        for (const child of header.children) {
          const result: any = getLastChild(child, column);
          if (result) return result;
        }
      }
      return null;
    };

    useEffect(() => {
      if (flattenedResults) {
        if (gridRef.current && gridRef.current.api && !isLoading) {
          const newSortedData = [];
          const displayedRowCount = gridRef.current.api.getDisplayedRowCount();
          for (let i = 0; i < displayedRowCount; i++) {
            const rowNode = gridRef.current.api.getDisplayedRowAtIndex(i);

            if (rowNode && rowNode.data) {
              newSortedData.push(rowNode.data);
            }
          }
          setSortedData(newSortedData);
        }
      }
    }, [queryMode, flattenedResults]);

    const onSortChanged = () => {
      if (gridRef.current && gridRef.current.api && !isLoading) {
        const newSortedData = [];
        const displayedRowCount = gridRef.current.api.getDisplayedRowCount();
        for (let i = 0; i < displayedRowCount; i++) {
          const rowNode = gridRef.current.api.getDisplayedRowAtIndex(i);

          if (rowNode && rowNode.data) {
            newSortedData.push(rowNode.data);
          }
        }
        setSortedData(newSortedData);
        const columnState = gridRef.current.api.getColumnState();
        const updatedColumnState = columnState
          .map((column: any) => {
            if (column.sort === null) {
              return null; // Skip columns with null sort and return null
            }
            let headerOrChild: { levelUniqueName?: string } | undefined;
            flattenedResults?.result.headers.find((header: any) => {
              if (header.field === column.colId) {
                headerOrChild = header;
              } else if (header.children && header.children.length > 0) {
                const lastChild = getLastChild(header, column);
                if (lastChild) {
                  headerOrChild = lastChild;
                }
              }
            });
            return {
              colId: column.colId,
              sort: column.sort,
              levelUniqueName: headerOrChild?.levelUniqueName || column.colId,
              sortIndex: column.sortIndex,
              //headerTooltip: column?.headerName,
              //tooltipField: column?.field,
              //flex: 1,
              // width:"auto",
              // minWidth: 120,
              //cellClass: column?.levelUniqueName && hasMatch(column.levelUniqueName, ["Measures"]) ? 'text-right' : 'text-left',
            };
          })
          .filter((column: any) => column !== null)
          .sort((a: any, b: any) => (a.sortIndex || 0) - (b.sortIndex || 0));

        if (query) {
          const updatedQuery = { ...query, gridSorts: updatedColumnState };
          dispatch(setQuery({ query: updatedQuery, currentTabIndex }));
          // dispatch(setQuery({ query: updatedQuery, currentTabIndex }));
        }
      }
    };

    const onFilterChanged = (event: any) => {
      if (gridRef.current && gridRef.current.api) {
        const eventFilter = event.api.getFilterModel();

        const filteredData = [];
        const api = gridRef.current!.api;
        const displayedRowCount =
          api.getDisplayedRowCount() - (api.getDisplayedRowCount() > 1 ? 1 : 0);

        const displayedColumns = gridRef.current.api.getAllDisplayedColumns();

        setResultInfo(
          `Showing : ${displayedRowCount} Row(s), ${displayedColumns.length} Column(s)`,
        );
        let enhFilter: any = { ...query?.enhancedFilterCriteria };
        if (eventFilter[event.columns[0].colId] === undefined) {
          const renderedValues = gridRef.current.api
            .getRenderedNodes()
            .map((node: any) => node.data[event.columns[0].colId]);
          enhFilter = convertFilterToEnhancedFilterCriteria(renderedValues);
        } else if (eventFilter[event.columns[0].colId].values.length === 0) {
          return;
        } else {
          enhFilter = convertFilterToEnhancedFilterCriteria(
            eventFilter[event.columns[0].colId].values,
          );
        }
        const updatedEnhFilter = {
          ...query?.enhancedFilterCriteria,
          [event.columns[0].colDef.levelUniqueName]: enhFilter,
        };

        // if (query) {
        //   const updatedQuery = {
        //     ...query,
        //     enhancedFilterCriteria: updatedEnhFilter,
        //   };
        //   dispatch(setQuery(updatedQuery));
        //   dispatch(setupQuery(updatedQuery));
        // }

        // Apply filtered data to charts

        for (let i = 0; i < displayedRowCount; i++) {
          const rowNode = gridRef.current.api.getDisplayedRowAtIndex(i);
          if (rowNode && rowNode.data) {
            filteredData.push(rowNode.data);
          }
        }
        setSortedData(filteredData);
      }
    };

    const updateResultInfo = () => {
      if (gridRef.current) {
        const api = gridRef.current!.api;
        const displayedRowCount =
          api.getDisplayedRowCount() - (api.getDisplayedRowCount() > 1 ? 1 : 0);
        const displayedColumns =
          gridRef.current?.api?.getAllDisplayedColumns() ||
          flattenedResults?.result?.queryRuntime?.cols;
        setResultInfo(
          `Showing : ${displayedRowCount} Row(s), ${
            displayedColumns?.length || 0
          } Column(s)`,
        );
      }
    };
    const handleToggle = (mode: string) => {
      const isMapMode = mode === "Map";
      const isVizMode = mode === "Viz";
      const newShowMap = isMapMode ? !showMap : false;
      const newShowChart = isVizMode ? !showChart : false;
      setShowMap(newShowMap);
      setShowChart(newShowChart);

      if (newShowChart) {
        dispatchQueryMode("Viz");
        dispatch(setQuerySubType({ type: "bar", currentTabIndex }));
      } else if (newShowMap) {
        /*if (query) { // Get the latest results
                dispatch(resultQuery(query));
            }*/
        dispatchQueryMode("Map");
        dispatch(setQuerySubType({ type: "thematic", currentTabIndex }));
      } else {
        dispatchQueryMode("Grid");

        dispatch(setQuerySubType({ type: null, currentTabIndex }));
      }
    };

    const [selectedMeasure, setSelectedMeasure] = useState<string | null>(null);
    const [selectedMeasureField, setSelectedMeasureField] = useState<
      string | null
    >(null);
    //Map to change counts based on measure change
    const onHeaderCellClicked = (params: any) => {
      if (
        queryMode === "Map" &&
        params.column.colDef.field &&
        params.column.colDef.levelUniqueName &&
        checkIsMeasureAttr(params.column.colDef.levelUniqueName)
      ) {
        setSelectedMeasure(params.column.colDef.headerName);
        setSelectedMeasureField(params.column.colDef.field);
      }
    };
    useEffect(() => {
      setSelectedMeasure(null);
      setSelectedMeasureField(null);
    }, [query?.axes]);
    const openExportModal = useModal(<ExportPopup />);

    const exportClickHandler = () => {
      const rows: any[] = [];
      gridRef.current?.api?.getColumnDefs()?.forEach((col: any) => {
        if (query?.axes.ROWS.indexOf(col.levelUniqueName) !== -1) {
          rows.push(col.levelUniqueName);
        }
      });
      if (query != null && query.axes && !arraysEqual(query.axes.ROWS, rows)) {
        const updatedQuery = {
          ...query,
          axes: {
            ...query.axes,
            ROWS: rows,
          },
        };

        // dispatch(setupQuery({payload:updatedQuery, index:currentTabIndex})).then(() => {
        //   openExportModal();
        //   dispatch(setQuery({query:updatedQuery,currentTabIndex}));
        //   //dispatch(resultQuery(updatedQuery));
        // });

        openExportModal();
      } else {
        openExportModal();
      }
    };

    const fullScreen = () => {
      const elements = document.getElementsByClassName(
        "results form-container",
      );
      if (elements.length > 0) {
        const element = elements[0]; // Get the first element with the specified class
        if (element) {
          if (element.requestFullscreen) {
            element.requestFullscreen();
          }
        }
      }
    };
    const hasRunRef = useRef(false);
    const location = useLocation();
    const cubes = useSelector((state: any) => state.meta.cubesMap);
    const [chartType, setChartType] = useState<any>("bar");
    const [mapType, setMapType] = useState<any>("thematic");
    const currentUser = useSelector((state: RootState) => state.user.user.name);
    const queryName = useSelector(
      (state: RootState) => state.save.savedQueryName,
    );
    useEffect(() => {
      if (queryName?.length > 0) {
        setQueryName(queryName[currentQueryIndex]);
      }
    }, [queryName]);

    const prevTabIndexRef = useRef(currentTabIndex);
    useEffect(() => {
      if (isSourceHistory) return;
      const tabIndexChanged = prevTabIndexRef.current !== currentTabIndex;
      if (tabIndexChanged) {
        prevTabIndexRef.current = currentTabIndex;

        return;
      }
      if (queryMode === "Viz") {
        setShowChart(true);
        setChartType("bar");
      } else if (queryMode === "Map") {
        setShowMap(true);
        setMapType(querySubType);
      } else if (queryMode === "Grid") {
        setShowMap(false);
        setShowChart(false);
      }
    }, [queryMode]);

    const loadAllTab = (
      index: number,
      tabName: string | null,
      cubeName: string,
      cubes: Record<string, Cube[]>,
    ) => {
      const cube = (Object.values(cubes).flat() as Cube[]).find(
        (c: Cube) => c.name === cubeName,
      );
      if (!cube) return;
      if (index > 0) {
        dispatch(setCurrUpdatingTabIndex(index));
        dispatch(addNewTab(tabName));
        dispatch(addNewMapQuery());
        dispatch(addNewMetaState());
        dispatch(setIsSavedQueryLoaded({ flag: true, currentTabIndex }));
      }
      dispatch(changeTabName({ tabName: tabName || "", index }));
      dispatch(
        setSelectedCube({ selectedCube: cube, currentActiveTab: index }),
      );
    };

    const processQuery = async (
      index: number,
      queryId: string,
      cubeName: string,
      cubes: Record<string, Cube[]>,
      owner: string,
      tabName: string | null,
      isInitialTime: boolean,
    ) => {
      if (index == 0) {
        setShowMap(false);
        setShowChart(false);
      }
      const cube = (Object.values(cubes).flat() as Cube[]).find(
        (c: Cube) => c.name === cubeName,
      );

      if (!cube) return;
      if (!isInitialTime && index > 0) {
        dispatch(setIsLoadingQuery({ flag: true, currentTabIndex: index }));
      }
      const formData = new FormData();
      formData.append("cube", cube.name);
      formData.append("schema", cube.schema);

      let newQueryResult: any = null;
      let updatedQuery: any = null;
      let queryInfo: any = null;
      if (isInitialTime) {
        newQueryResult = await dispatch(newQuery({ formData, index }));

        const loadResult: any = await dispatch(
          loadQuery({
            groupId: queryId,
            name: newQueryResult?.payload?.name || query?.name || "",
          }),
        );

        const { QueryInfo, Query } = loadResult.payload;
        queryInfo = QueryInfo;
        if (QueryInfo?.mapOptions?.measureSelections) {
          dispatch(
            setMsrSelections({
              msr: QueryInfo?.mapOptions?.measureSelections,
              currentTabIndex: index,
            }),
          );
        }
        dispatch(
          setQuerySubType({ type: QueryInfo.subType, currentTabIndex: index }),
        );

        updatedQuery = {
          ...Query,
          gridSorts: QueryInfo.gridSorts ?? Query.gridSorts,
          owner,
        };

        dispatch(setQuery({ query: updatedQuery, currentTabIndex: index }));
        if (isInitialTime) {
          if (queryInfo?.type === "Viz") {
            dispatchQueryMode("Viz", index);
          } else if (queryInfo.type === "Map") {
            dispatchQueryMode("Map", index);
          } else {
            dispatchQueryMode("Grid", index);
          }
        }

        dispatch(setLoadQueryMode({ flag: false, currentTabIndex: index }));
      }
      if ((isInitialTime && index == 0) || (!isInitialTime && index > 0) || (!isInitialTime && index == 0 && (!measures || !dimensions || !metadataGroup))) {
        if (
          selectedCube &&
          selectedCube.name ==
            (isInitialTime ? newQueryResult : query.cubeName) &&
          (index > 0 || (!isInitialTime && index == 0 && (!measures || !dimensions || !metadataGroup)))
        ) {
          const connection = selectedCube?.connection;
          const catalog = selectedCube?.catalog;
          const schema = selectedCube?.schema;
          const cube = selectedCube?.name;
          await dispatch(
            getMetadata({
              connection,
              catalog,
              schema,
              cube,
              currentTabIndex: index,
            }),
          );
        }
        dispatch(setIsSavedQueryLoaded({ flag: true, currentTabIndex: index }));

        const type = isInitialTime ? queryInfo.type : queryMode;
        const subType = isInitialTime ? queryInfo.subType : querySubType;
        await dispatch(
          resultQuery({
            query: updatedQuery || query,
            queryMode: type,
            querySubType: subType,
            index,
          }),
        );

        if (type === "Viz") {
          dispatchQueryMode("Viz");
          setShowChart(true);
          setChartType(subType);
        } else if (type === "Map") {
          dispatchQueryMode("Map");
          setShowMap(true);
          setMapType(subType);
        } else {
          dispatchQueryMode("Grid");
          setShowMap(false);
          setShowChart(false);
        }
        // } else {
        //   dispatch(setLoadQueryMode(true));
        //   dispatch(setLoading(false));
        //   await dispatch(
        //     getMapResult({
        //       selectedMap: QueryInfo.subType,
        //       currentTabIndex:index,
        //     })
        //   );
        // }

        setIsLoadQuery(false);
        dispatch(setIsLoadingQuery({ flag: false, currentTabIndex: index }));
      }
    };

    /**
     * Open a legacy TipNet query as a new ephemeral OLAP session.
     * Replaces the loadQuery step with the already-parsed { QueryInfo, Query }
     * stored in state.save.pendingLegacyQuery.
     */
    const processLegacyQuery = async (parsed: any, name: string) => {
      setShowMap(false);
      setShowChart(false);

      const { Query: parsedQuery, QueryInfo: parsedQueryInfo } = parsed;

      const allCubes = Object.values(cubes).flat() as Cube[];

      const cube = allCubes.find(
        (c: Cube) =>
          c.name === parsedQuery.cubeName ||
          c.schema === parsedQuery.schemaName,
      );

      if (!cube) {
        console.warn(
          `[processLegacyQuery] Cube "${parsedQuery.cubeName}" not found in cubesMap.`,
        );
        dispatch(
          showNotification({
            message: `Could not find cube for legacy query "${name}"`,
            duration: 4000,
            isError: true,
          }),
        );
        dispatch(setIsLoadingSavedQueries(false));
        setIsInitialLoading(false);
        return;
      }

      // Set cube and tab name so the left panel reflects the correct cube
      dispatch(setSelectedCube({ selectedCube: cube, currentActiveTab: 0 }));
      dispatch(changeTabName({ tabName: name, index: 0 }));

      const formData = new FormData();
      formData.append("cube", cube.name);
      formData.append("schema", cube.schema);

      // Create a blank OLAP session — gives us the server-side session name
      const newQueryResult: any = await dispatch(
        newQuery({ formData, index: 0 }),
      );

      // Merge parser output with server-assigned session name
      const updatedQuery = {
        ...parsedQuery,
        name: newQueryResult?.payload?.name || "",
        owner: currentUser || "",
      };

      dispatch(setQuery({ query: updatedQuery, currentTabIndex: 0 }));
      dispatch(
        setQuerySubType({ type: parsedQueryInfo.subType, currentTabIndex: 0 }),
      );
      dispatchQueryMode("Grid", 0);
      dispatch(setLoadQueryMode({ flag: false, currentTabIndex: 0 }));
      dispatch(setSavedQueryName({ name, index: 0 }));
      setQueryName(name);

      // Register axes + filters on the server, then run
      await dispatch(setupQuery({ payload: updatedQuery, index: 0 }));

      dispatch(setIsSavedQueryLoaded({ flag: true, currentTabIndex: 0 }));

      await dispatch(
        resultQuery({
          query: updatedQuery,
          queryMode: "Grid",
          querySubType: "",
          index: 0,
        }),
      );

      dispatchQueryMode("Grid");
      setShowMap(false);
      setShowChart(false);
      setIsLoadQuery(false);

      // Clear pending legacy query from Redux now that it's been consumed
      dispatch(setPendingLegacyQuery(null));

      dispatch(setIsLoadingSavedQueries(false));
      setIsInitialLoading(false);

      // Strip legacy params from URL (same as processAllQueries does for native)
      const newUrl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname;
      window.history.replaceState({}, document.title, newUrl);
    };

    const processAllQueries = async (owner: string, name: string) => {
      for (const [index, item] of loadedQueryIds.entries()) {
        dispatch(setSavedQueryName({ name, index }));
        loadAllTab(index, item.tabName, item.cubeName, cubes);
      }
      for (const [index, item] of loadedQueryIds.entries()) {
        await processQuery(
          index,
          item.queryId,
          item.cubeName,
          cubes,
          owner,
          item.tabName,
          true,
        );
      }
      dispatch(setIsLoadingSavedQueries(false));

      setIsInitialLoading(false);

      const newUrl =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname;
      window.history.replaceState({}, document.title, newUrl);
    };

    useEffect(() => {
      if (!isSavedQueryLoaded && !isLoadingSavedQuery) {
        const queryItem = loadedQueryIds[currentTabIndex];
        processQuery(
          currentTabIndex,
          queryItem.queryId,
          queryItem.cubeName,
          cubes,
          user?.name || "",
          queryItem.tabName,
          false,
        );
      }
    }, [currentTabIndex, isSavedQueryLoaded, isLoadingSavedQuery]);

    useEffect(() => {
      const urlParams = new URLSearchParams(window.location.search);
      const id = urlParams.get("id");
      // const queryId = urlParams.get("queryId");
      let name = urlParams.get("name") || "";
      // const cubeName = urlParams.get("cube");
      const owner = urlParams.get("owner") || "";
      if (urlParams.get("legacy") === "true") {
        // Legacy TipNet query path — pendingLegacyQuery set by SavedQueriesList before navigate
        dispatch(setIsLoadingSavedQueries(true));
        setIsInitialLoading(true);
        setIsLoadQuery(true);
        setQueryName(name);
        if (
          cubes &&
          Object.values(cubes).flat().length > 0 &&
          pendingLegacyQuery
        ) {
          if (hasRunRef.current) return;
          hasRunRef.current = true;
          processLegacyQuery(pendingLegacyQuery, name);
        }
      } else if (id) {
        dispatch(setIsLoadingSavedQueries(true));

        setIsInitialLoading(true);
        dispatch(saveGroupId(id)); // Save the query ID to the Redux store
        dispatch(saveQueryId(id));
        dispatch(saveQueryIds(loadedQueryIds.map((q: any) => q.queryId)));
        setIsLoadQuery(true);
        setQueryName(name);
        if (cubes && Object.values(cubes).flat().length > 0) {
          if (hasRunRef.current) return;
          hasRunRef.current = true;

          processAllQueries(owner, name);
        }
      } else if (loadedQueryIds[currentTabIndex]?.queryId) {
        if (
          query === undefined ||
          query === null ||
          query.cubeName !== selectedCube?.name
        ) {
          defaultNewQuery(false);
        }
        return;
      } else {
        if (
          query === undefined ||
          query === null ||
          query.cubeName !== selectedCube?.name
        ) {
          defaultNewQuery(false);
        }
      }
    }, [location.search, cubes, selectedCube]);

    useEffect(() => {
      if (selectedCube) {
        const dataLoadDate = selectedCube.annotations["load.date"];
        if (dataLoadDate) {
          setDataloadInfo(
            `${selectedCube.caption} - Data as of ${dataLoadDate}`,
          );
        } else {
          setDataloadInfo(null);
        }
      }
    }, [selectedCube]);
    useEffect(() => {
      if (gridRef.current && gridRef.current.api && !isLoadQuery) {
        if (!query?.gridSorts || query.gridSorts.length === 0) {
          gridRef.current.api.applyColumnState({
            defaultState: { sort: null, sortIndex: null },
          });
          return;
        }
        const columnState = gridRef.current.api
          .getColumnState()
          .map((col: any) => {
            const sort = query.gridSorts.find(
              (s: any) => s.colId === col.colId,
            );
            return {
              ...col,
              sort: sort ? sort.sort : null,
              sortIndex: sort ? sort.sortIndex : null,
              flex: 1,
              headerTooltip: col?.headerName,
              tooltipField: col?.field,
              minWidth: 120,
              cellClass:
                col?.levelUniqueName &&
                hasMatch(col.levelUniqueName, ["Measures"])
                  ? "text-right"
                  : "text-left",
            };
          });
        gridRef.current.api.applyColumnState({
          state: columnState,
          applyOrder: true,
        });
        if (isLoadQuery) {
          setIsLoadQuery(false);
        }
      }
    }, [query?.gridSorts, isLoadQuery, gridRef.current?.api, rowData]);

    const formatNumberWithCommas = (value: number) => {
      if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return value;
      }
    };
    const applyCellClassRules = (header: any, index: number, headers: any) => {
      return {
        ...header,
        cellRenderer: (params: any) => {
          if (
            params.colDef.levelUniqueName &&
            params.colDef.levelUniqueName.indexOf(
              "[Measures].[MeasuresLevel]",
            ) != -1
          ) {
            if (params.node.aggData && flattenedResults) {
              //return 'Sum: ' + formatNumberWithCommas(params.value) + ' Avg: ' + formatNumberWithCommas(Math.trunc(params.value/flattenedResults?.result.rows.length));
              //return formatNumberWithCommas(params.value);
              return QueryResultAggregator(
                params.value,
                Math.trunc(params.value / flattenedResults?.result.rows.length),
              );
            }
            return formatNumberWithCommas(params.value);
          } else {
            return params.value;
          }
        },
        cellClass: (params: any) => {
          if (
            params.colDef.levelUniqueName.indexOf(
              "[Measures].[MeasuresLevel]",
            ) != -1
          ) {
            if (params.node.aggData) {
              return "text-right agg-cell";
            } else {
              return "text-right";
            }
          }
        },
      };
    };

    const getRowHeight = (params: any) => {
      if (params.node.aggData) {
        return 50;
      } // Light gray background
      return 25; // No specific style
    };

    const getRowStyle = (params: RowClassParams) => {
      if (params.node.aggData) {
        return { backgroundColor: "#f0f0f0", fontWeight: "bold" }; // Light gray background
      }
    };

    const applyRulesRecursively = (header: any, index: any, headers: any) => {
      const updatedHeader = applyCellClassRules(header, index, headers);

      if (header.children) {
        updatedHeader.children = header.children.map((childHeader: any) =>
          applyRulesRecursively(childHeader, index, headers),
        );
      }
      return { ...header, ...updatedHeader };
    };

    const handleGroupFn = (flag: string, fn: string) => {
      if (query) {
        dispatch(
          groupFnQuery({ query, flag, fn, index: currentTabIndex }),
        ); /*.then((result: any) => {
                setRowData(result.payload.result.rows);
                const updatedColDef = result.payload.result.headers.map((header: any, index: any) => {
                    const existingColDef = columnDefs.find((col) => col.field === header.field);
                    const updatedHeader = applyRulesRecursively(header, index, result.payload.result.headers);
                    return {
                        ...header,
                        ...existingColDef, // Preserve existing metadata
                        ...updatedHeader,
                    };
                });
                setColumnDefs(updatedColDef);
            });*/
      }
    };
    useImperativeHandle(ref, () => ({
      callResetAll() {
        resetQuery(true);
      },
      getQueryName() {
        return savedQueryName;
      },
    }));

    const resetQuery = async (isAll: boolean) => {
      if (isAll) {
        setShowConfirmPopup(true);
        setConfirmPopUp({
          title: "Reset All Tabs",
          message:
            "Are you sure you want to reset all tabs? This will discard any unsaved changes.",
          confirmAction: (title: string, id: number) => {
            const newUrl =
              window.location.protocol +
              "//" +
              window.location.host +
              window.location.pathname;
            window.history.replaceState({}, document.title, newUrl);
            setIsLoadQuery(false);
            dispatch(resetQuerySlice());
            dispatch(resetMapSlice());
            dispatch(resetMetaState());
            dispatch(saveQueryIds([]));
            dispatch(setLoadQueryIds([]));
            setRowData([]);

            dispatch(saveQueryId(null));
            dispatch(saveGroupId(null));
            dispatch(setSaveQueryNameToAll(["New Query"]));
            setQueryName("New Query");
          
            setTimePeriod("Time Periods");
            setActivePanelTab('displayFields');
            setShowConfirmPopup(false);
          },
          closeAction: () => {
            setShowConfirmPopup(false);
          },
          id: 0,
        });
      } else {
        if (savedQueryName === "New Query" || isQueryUpdated) {
          setShowConfirmPopup(true);
          setConfirmPopUp({
            title: "Reset Query",
            message:
              "Are you sure you want to reset the query? This will discard any unsaved changes.",
            confirmAction: (title: string, id: number) => {
              setIsLoadQuery(false);
              dispatch(setResults({ result: null, currentTabIndex }));
              setRowData([]);
              defaultNewQuery(false);
              const newQueryIds = [...queryIds];
              newQueryIds[currentTabIndex] = null;
              dispatch(saveQueryId(null));
              dispatch(saveQueryIds(newQueryIds));
              if (tabs.length <= 1) {
                dispatch(saveGroupId(null));
                dispatch(
                  setSavedQueryName({
                    name: "New Query",
                    index: currentTabIndex,
                  }),
                );
                setQueryName("New Query");
              } else {
              }
              dispatch(setMapData({ data: null, currentTabIndex }));

              setTimePeriod("Time Periods");
            dispatch(resetTabname({  index: currentTabIndex }));

            setActivePanelTab('displayFields');

              setShowConfirmPopup(false);
            },
            closeAction: () => {
              setShowConfirmPopup(false);
            },
            id: 0,
          });
        } else {
          setIsLoadQuery(false);
          defaultNewQuery(false);
          dispatch(saveQueryId(null));
          const newQueryIds = [...queryIds];
          newQueryIds[currentTabIndex] = null;
          dispatch(saveQueryIds(newQueryIds));
          if (tabs.length <= 1) {
            dispatch(saveGroupId(null));
            dispatch(
              setSavedQueryName({ name: "New Query", index: currentTabIndex }),
            );
            setQueryName("New Query");
          } else {
          }
          dispatch(setMapData({ data: null, currentTabIndex }));
            dispatch(resetTabname({  index: currentTabIndex }));
            setActivePanelTab('displayFields');

          setTimePeriod("Time Periods"); // Reset timePeriod here0
        }
        dispatch(setAxesWithAllSelected({ axes: [], currentTabIndex }));
      }
    };
    useEffect(() => {
      if (mapResults && queryMode == "Map") {
        const newRowData = mapResults.result.rows.map((row: any) => {
          const newRow = { ...row };
          Object.keys(newRow).forEach((key: string) => {
            if (typeof newRow[key] === "object") {
              newRow[key] = newRow[key][0];
            }
          });
          return newRow;
        });

        const checkNestedChildren = (
          children: any[],
          caption: string,
        ): boolean => {
          return children.some((child: any) => {
            if (child.headerName === caption) {
              return true;
            }
            if (child.children && Array.isArray(child.children)) {
              return checkNestedChildren(child.children, caption);
            }
            return false;
          });
        };

        let newColumnDefs = mapResults.result.headers.map((header: any) => ({
          ...header,
        }));
        measures?.forEach((measure: any) => {
          newColumnDefs = newColumnDefs.map((column: any) => {
            const newColumn = {
              ...column,
              headerTooltip: column?.headerName,
              tooltipField: column?.field,
              flex: 1,
              minWidth: 120,
              cellClass:
                column?.levelUniqueName &&
                hasMatch(column.levelUniqueName, ["Measures"])
                  ? "text-right"
                  : "text-left",
            };
            const isMeasureMatch = newColumn.children
              ? checkNestedChildren(newColumn.children, measure.caption)
              : newColumn.headerName === measure.caption;

            if (isMeasureMatch) {
              if (newColumn.children) {
                newColumn.children = newColumn.children.map((child: any) => {
                  if (child.children && Array.isArray(child.children)) {
                    const updatedNestedChildren = child.children.map(
                      (nestedChild: any) => ({
                        ...nestedChild,
                        comparator: createNumericComparator(),
                        sortable: queryMode === "Map" ? false : true,
                        headerTooltip: nestedChild?.headerName,
                        tooltipField: nestedChild?.field,
                        flex: 1,
                        minWidth: 120,
                        cellClass:
                          nestedChild?.levelUniqueName &&
                          hasMatch(nestedChild.levelUniqueName, ["Measures"])
                            ? "text-right"
                            : "text-left",
                      }),
                    );
                    return {
                      ...child,
                      children: updatedNestedChildren,
                      comparator: createNumericComparator(),
                      sortable: queryMode === "Map" ? false : true,
                      headerTooltip: child?.headerName,
                      tooltipField: child?.field,
                      flex: 1,
                      minWidth: 120,
                      cellClass:
                        child?.levelUniqueName &&
                        hasMatch(child.levelUniqueName, ["Measures"])
                          ? "text-right"
                          : "text-left",
                    };
                  }
                  // Return the child as is if it doesn't have nested children
                  return {
                    ...child,
                    comparator: createNumericComparator(),
                    sortable: queryMode === "Map" ? false : true,
                  };
                });
              } else {
                return {
                  ...newColumn,
                  comparator: createNumericComparator(),
                  sortable: queryMode === "Map" ? false : true,
                };
              }
            }
            return newColumn;
          });
        });
        const totalWidth = countHeaders(newColumnDefs) * 210;
        setRowData(newRowData);
        setColumnDefs(newColumnDefs);
        setStyle((prevStyle) => ({ ...prevStyle, width: totalWidth }));
      }
    }, [mapResults, queryMode]);

    const exportData = async (format: string) => {
      setIsExportQuery(true);
      const fileName = `export-${new Date().toISOString()}`;
      const formData = new FormData();
      const rows: any[] = [];
      gridRef.current?.api?.getColumnDefs()?.forEach((col: any) => {
        if (query?.axes.ROWS.indexOf(col.levelUniqueName) !== -1) {
          rows.push(col.levelUniqueName);
        }
      });
      if (query != null && query.axes && !arraysEqual(query.axes.ROWS, rows)) {
      }
      formData.append(
        "args",
        JSON.stringify([
          {
            isMap: queryMode === "Map" ? true : false,
            vizType: queryMode,
            format: format,
            queryName: query?.name,
            noLimit: false,
            tabName: "Tab1",
            showFlattened: true,
            gridSorts:
              query?.gridSorts?.map((gridSort: any) => {
                return {
                  colId: gridSort.colId,
                  sort: gridSort.sort,
                  levelUniqueName: gridSort.levelUniqueName,
                  sortIndex: gridSort.sortIndex,
                };
              }) || [],
          },
        ]),
      );
      close();
      const fileUrl = await dispatch(
        exportRequest({ fileName, format, formData }),
      ).unwrap();
      if (!fileUrl) {
        alert("Failed to export file");
      } else {
        handleDownload(fileUrl);
      }
    };

    const handleDownload = async (fileUrl: string) => {
      try {
        setIsExportQuery(false);
        dispatch(
          showNotification({
            message: "File is being downloaded",
            duration: 3000,
          }),
        );
        window.location.href = fileUrl;
      } catch (error) {
        setIsExportQuery(false);
        console.error("Error downloading file:", error);
      }
    };

    useEffect(() => {
      setIsExportQuery(exportQueryFlag);
    }, [exportQueryFlag]);

    /*const [draggedColumns, setDraggedColumns] = useState(   {
        fromIndex: 0,
        toIndex: 0,
    });*/

    const [draggedColumns, setDraggedColumns] = useState([]);

    const [columnDragged, setColumnDragged] = useState({
      fromIndex: 0,
      toIndex: 0,
    });

    const onColumnMoved = (event: ColumnMovedEvent<Result>) => {
      // check if the column is moved to the Measures level using query object
      // get the index of all measure columns in the columnDefs\
      if (!query) {
        return;
      }
      const levelName =
        event &&
        event.column &&
        event.column.getColDef() &&
        (event.column.getColDef() as any).levelUniqueName
          ? (event.column.getColDef() as any).levelUniqueName
          : "";
      const originalIndex = query.axes.ROWS.findIndex(
        (row: any) => row === levelName,
      );
      if (
        typeof event.toIndex === "number" &&
        query?.axes?.ROWS?.length !== undefined &&
        event.toIndex >= query.axes.ROWS.length
      ) {
        // If the column is moved to the Measures level, reset this operation
        event.api.moveColumnByIndex(event.toIndex, originalIndex);
      } else {
        if (
          flattenedResults &&
          flattenedResults.result.headers &&
          gridRef &&
          gridRef.current &&
          gridRef.current.api
        ) {
          // update headers in flattenedResults based on the new order
          // first check if order is different in flattenedResults && columnDefs //
          const currentOrder = flattenedResults.result.headers.map(
            (header: any) => {
              return {
                levelUniqueName: header.levelUniqueName,
                columnName: header.headerName,
              };
            },
          );
          const newOrder =
            gridRef.current.api?.getColumnDefs()?.map((col: any) => {
              return {
                levelUniqueName: col.levelUniqueName,
                columnName: col.headerName,
              };
            }) || [];
          if (deepEqual(currentOrder, newOrder)) {
            return;
          }
          const headers: any[] = [];
          newOrder.forEach((row: any) => {
            const existingCol = flattenedResults?.result.headers.find(
              (col: any) =>
                col.levelUniqueName === row.levelUniqueName &&
                col.headerName === row.columnName,
            );
            if (existingCol) {
              headers.push(existingCol);
            }
          });

          dispatch(setResultHeaders({ headers, currentTabIndex }));
        }
      }
    };

    // TimeSpan Selector
    const levels =
      metadataGroup?.find(
        (group: { name: string; levels: any }) => group.name === "Time Period",
      )?.levels || [];
    const levelTitleMap = levels.reduce(
      (acc: { [key: string]: string }, level: any) => {
        const title = level
          .split(".")
          .pop()
          ?.replaceAll("[", "")
          .replaceAll("]", ""); // Extract title
        acc[title] = level; // Map level to its title
        return acc;
      },
      {},
    );

    const [timePeriod, setTimePeriod] = useState(
      Object.keys(levelTitleMap)[0] || "Time Periods",
    ); // Default to 'Time Periods' if available, else first level title

    useEffect(() => {
      if (query && levelTitleMap) {
        const axes = [...query.axes.ROWS, ...query.axes.COLUMNS];
        const hasTitleLevelMapKey = axes.some((axis) =>
          Object.keys(levelTitleMap).includes(
            axis.split(".").pop()?.replaceAll("[", "").replaceAll("]", "") ||
              "",
          ),
        );
        if (!hasTitleLevelMapKey) {
          setTimePeriod("");
        } else if (hasTitleLevelMapKey) {
          setTimePeriod(
            Object.keys(levelTitleMap).find((title) =>
              axes.includes(levelTitleMap[title]),
            ) || "",
          );
        }
      }
    }, [query, levelTitleMap]);

    useEffect(() => {
      if (
        queryMode == "Viz" &&
        flattenedResults?.result?.mergeCount?.rowCount > 50 &&
        chartType == "pie"
      ) {
        setIsError(true);
      } else if (
        chartType === "pie" &&
        flattenedResults?.result?.headers &&
        countMeasureNodes(flattenedResults.result.headers) > 1
      ) {
        setIsError(true);
      } else {
        setIsError(false);
      }
    }, [queryMode, flattenedResults, chartType]);
    const handleTimePeriodChange = (title: string) => {
      dispatch(setLoading({ flag: true, currentTabIndex }));
      setTimePeriod(title);
      if (query) {
        let updatedQuery = { ...query };
        const updateAxis = (axisType: "COLUMNS" | "ROWS") => {
          const containsTitle = updatedQuery.axes[axisType].some(
            (axis: string) =>
              axis.split(".").pop()?.replaceAll("[", "").replaceAll("]", "") ===
              title,
          );
          if (containsTitle) {
            return;
          }
          const updatedAxes = updatedQuery.axes[axisType].map(
            (axis: string) => {
              return axis.replace(
                levelTitleMap[timePeriod],
                levelTitleMap[title],
              );
            },
          );

          updatedQuery = {
            ...updatedQuery,
            axes: { ...updatedQuery.axes, [axisType]: updatedAxes },
          };
        };

        const updateBothAxes = () => {
          updateAxis("COLUMNS");
          updateAxis("ROWS");

          dispatch(setQuery({ query: updatedQuery, currentTabIndex }));
          dispatch(
            setupQuery({ payload: updatedQuery, index: currentTabIndex }),
          ).then((query: any) => {
            dispatch(
              resultQuery({
                query: query.payload,
                queryMode,
                querySubType,
                index: currentTabIndex,
              }),
            );
          });
        };
        updateBothAxes();
      }
    };
    const openReviewSelectionModel = useModal(<ReviewSelection />, "");
    return (
      <div
        className="right-panel query-chart"
        style={{
          flex: 1,
          flexDirection: "column",
          display: "flex",
          overflow: "hidden",
        }}
      >
        <div className="results-bar" style={{ padding: 0 }}>
          <div className="results-info" style={{ padding: "10px 13px" }}>
            {dataloadInfo && <div>{dataloadInfo}</div>}
          </div>

          <div className="results-icons">
            <IconButton
              onClick={() => {
                openReviewSelectionModel();
              }}
            >
              <ToolTip
                iconPositionCenter={true}
                position={"top"}
                message={"Review Selections"}
                icon={faFilter}
              />
            </IconButton>
            <IconButton
              disabled={
                currentQueryIndex == 0 || currentQueryIndex + 3 < historyCount
              }
              onClick={async () => {
                setShowChart(false);
                setShowMap(false);

                const historyData = await dispatch(
                  historyQuery({
                    index: currentQueryIndex - 1,
                    queryName: query?.name || "",
                    currentTabIndex,
                  }),
                );

                if (historyQuery.fulfilled.match(historyData)) {
                  const newQuery = {
                    ...query,
                    enhancedFilterCriteria:
                      historyData.payload.query.enhancedFilterCriteria,
                    axes: historyData.payload.query.axes,
                  };
                  dispatch(
                    setupQuery({ payload: newQuery, index: currentTabIndex }),
                  );
                }
              }}
            >
              <ToolTip
                position={"top"}
                message={"Undo"}
                iconPositionCenter={true}
                icon={faArrowRotateLeft}
              />
            </IconButton>
            <IconButton
              disabled={
                historyCount == 0 || currentQueryIndex + 1 == historyCount
              }
              onClick={async () => {
                const historyData = await dispatch(
                  historyQuery({
                    index: currentQueryIndex + 1,
                    queryName: query?.name || "",
                    currentTabIndex,
                  }),
                );
                if (historyQuery.fulfilled.match(historyData)) {
                  const newQuery = {
                    ...query,
                    enhancedFilterCriteria:
                      historyData.payload.query.enhancedFilterCriteria,
                    axes: historyData.payload.query.axes,
                  };
                  dispatch(
                    setupQuery({ payload: newQuery, index: currentTabIndex }),
                  );
                }
              }}
            >
              <ToolTip
                position={"top"}
                iconPositionCenter={true}
                message={"Redo"}
                icon={faArrowRotateRight}
              />
            </IconButton>

            {/* This below code is for reset and reset all dropdown I am commenting it becuase in future if we need this. */}
            {/* <ActionDropdown
            disabled={tabs.length <= 1}
            button={
              <IconButton
                   onClick={() => 
              tabs.length <= 1 ? resetQuery(false) : null

                   }
                >
            <ToolTip
              position={"top"}
              message={"Reset Query"}
              icon={faRefresh}
            />
              </IconButton>
            }
            menuClass="resetMenu"

          >
            <aside className="popup">
              <div className="popup-content">
                <div
                  className="menu-option"
                  style={{padding:"8px"}}
                  onClick={() => {
                    resetQuery(false);
                  }}
                >
                  <span>Reset Current Tab</span>
                </div>
              </div>
              <hr></hr>
              <div className="popup-content">
                <div
                  className="menu-option"
                  style={{padding:"8px"}}
                  onClick={() => {
                    resetQuery(true);
                  }}
                >
                  <span>Reset All Tabs</span>
                </div>
              </div>
            </aside>
          </ActionDropdown> */}

            <IconButton
              onClick={() => {
                resetQuery(false);
              }}
            >
              <ToolTip
                position={"top"}
                iconPositionCenter={true}
                message={"Reset Current Tab"}
                icon={faRefresh}
              />
            </IconButton>

            <IconButton onClick={() => fullScreen()}>
              <ToolTip
                position={"top"}
                iconPositionCenter={true}
                message={"Full Screen"}
                icon={faExpand}
              />
            </IconButton>

            <IconButton
              selected={queryMode == "Map"}
              disabled={
                (queryMode === "Grid" || queryMode === "Viz") &&
                (!canViewMap() || !showButton())
              }
              onClick={() => handleToggle("Map")}
            >
              <ToolTip
                position={"top"}
                message={"Map"}
                iconPositionCenter={true}
                icon={faGlobe}
              />
            </IconButton>
            <IconButton
              selected={queryMode == "Viz"}
              disabled={queryMode === "Grid" && !showButton()}
              onClick={() => handleToggle("Viz")}
            >
              <ToolTip
                position={"top"}
                iconPositionCenter={true}
                message={"Chart"}
                icon={faChartLine}
              />
            </IconButton>
            <IconButton
              disabled={
                isError ||
                (!showMap
                  ? !showButton()
                  : !mapResults || mapResults.progress === "Deferred")
              }
              onClick={() => {
                exportClickHandler();
              }}
            >
              <ToolTip
                iconPositionCenter={true}
                position={"top"}
                message={"Export"}
                icon={faFileExport}
              />
            </IconButton>
          </div>
        </div>
        <div className="results form-container">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div className="timespan">
              <TimeSelector
                titles={levelTitleMap}
                timePeriod={timePeriod}
                handleClick={handleTimePeriodChange}
              />
            </div>
            <div className="results-info">
              {/* {dataloadInfo && <div>{dataloadInfo}</div>} */}
              {rowData.length > 0 && <div>{resultInfo}</div>}
            </div>
          </div>

          {queryMode == "Viz" &&
            rowData.length > 0 &&
            flattenedResults?.activeQueryDetail?.queryMode == "Viz" && (
              <QueryChart
                key={currentTabIndex}
                ref={chartRef}
                isError={isError}
                currentTabIndex={currentTabIndex}
                data={sortedData}
                subType={querySubType}
              />
            )}
          {/* {showMap && canViewMap() && rowData.length > 0 && !isLoading && queryMode == "Map" && <Map selectedMeasure={selectedMeasure} selectedMeasureField={selectedMeasureField} subType={mapType} />} */}

          {queryMode == "Map" &&
            ((canViewMap() && rowData.length > 0) || isLoadQueryMode) && (
              <Map
                key={currentTabIndex}
                selectedMeasure={selectedMeasure}
                currentTabIndex={currentTabIndex}
                selectedMeasureField={selectedMeasureField}
                subType={mapType}
              />
            )}

          <div style={{ position: "relative" }}>
            {rowData.length > 0 && errorMessge == null && !isError && (
              <div className="ag-theme-alpine result-grid-wrapper">
                <div style={style}>
                  <AgGridReact
                    ref={gridRef}
                    rowData={rowData}
                    columnDefs={columnDefs}
                    headerHeight={headerHeight}
                    rowHeight={rowHeight}
                    suppressContextMenu={true}
                    onGridReady={onGridReady}
                    onSortChanged={onSortChanged}
                    onFilterChanged={onFilterChanged}
                    onFirstDataRendered={updateResultInfo}
                    onColumnVisible={updateResultInfo}
                    onRowDataUpdated={updateResultInfo}
                    onColumnHeaderClicked={onHeaderCellClicked}
                    alwaysMultiSort={true}
                    defaultColDef={{
                      sortable: true,
                      headerClass: "query-result-header",
                      suppressMovable: false,
                      suppressSizeToFit: true,

                      suppressAutoSize: false,
                      minWidth: 180,
                      resizable: true,

                      flex: 1,
                    }}
                    grandTotalRow={
                      flattenedResults?.result?.rows?.length &&
                      flattenedResults.result.rows.length > 1
                        ? "bottom"
                        : undefined
                    }
                    getRowHeight={(params) => getRowHeight(params)}
                    getRowStyle={getRowStyle}
                    onColumnMoved={onColumnMoved}
                  />
                </div>
              </div>
            )}
            {errorMessge != null && (
              <div
                style={{ paddingLeft: "10px", paddingTop: "10px" }}
                className="no-results"
              >
                {errorMessge}{" "}
              </div>
            )}
            {rowData.length === 0 &&
              availableOptions.length === 0 &&
              flattenedResults?.result.resultFill === "None" && (
                <div
                  style={{ paddingLeft: "10px", paddingTop: "10px" }}
                  className="no-results"
                >
                  No Results Found
                </div>
              )}

            {mapResults && mapResults.progress === "Aborted" && (
              <div
                style={{ paddingLeft: "10px", paddingTop: "10px" }}
                className="no-results"
              >
                Results exceed the permitted limit. Kindly adjust your filters
                to narrow down the data.
              </div>
            )}
            {flattenedResults &&
              (flattenedResults.progress === "Aborted" ||
                (flattenedResults.progress === "Deferred" &&
                  flattenedResults.availableOptions.length > 0 &&
                  flattenedResults.availableOptions[0] === "LargeQuery")) &&
              errorMessge === null && (
                <div
                  style={{ paddingLeft: "10px", paddingTop: "10px" }}
                  className="no-results"
                >
                  Results exceed the permitted limit. Kindly adjust your filters
                  to narrow down the data.
                </div>
              )}

            {/*             
          {
           showMap && flattenedResults?.result?.mergeCount?.cellCount && flattenedResults.result.mergeCount.cellCount >= 75000 && 
              <div
                style={{ paddingLeft: "10px", paddingTop: "10px" }}
                className="no-results"
              >
                Results exceed the permitted limit. Kindly adjust your filters
                to narrow down the data.
              </div>
          } */}
            {!showMap &&
              flattenedResults &&
              flattenedResults.progress === "Deferred" &&
              errorMessge === null && (
                <div style={{ paddingLeft: "10px", paddingTop: "10px" }}>
                  {flattenedResults &&
                    flattenedResults.availableOptions.length > 1 && (
                      <>
                        <div>
                          The query would produce a result too large to display.
                          You can choose one of the export option(s) below (or)
                          add filters or remove fields to run the query
                        </div>
                        <div className="export-button-parent">
                          {flattenedResults.availableOptions.indexOf("Xlsx") >
                            -1 && (
                            <Button
                              color="secondary"
                              className="export-button"
                              onClick={() => {
                                exportData("xlsx");
                              }}
                            >
                              Export to Excel
                            </Button>
                          )}
                          {flattenedResults.availableOptions.indexOf("Pdf") >
                            -1 && (
                            <Button
                              color="secondary"
                              className="export-button"
                              onClick={() => {
                                exportData("pdf");
                              }}
                            >
                              Export to PDF
                            </Button>
                          )}
                          {flattenedResults.availableOptions.indexOf("Csv") >
                            -1 && (
                            <Button
                              color="secondary"
                              className="export-button"
                              onClick={() => {
                                exportData("csv");
                              }}
                            >
                              Export to CSV
                            </Button>
                          )}
                        </div>
                      </>
                    )}
                </div>
              )}
            {showMap &&
              mapResults &&
              mapResults.progress === "Deferred" &&
              errorMessge === null && (
                <>
                  {" "}
                  <div
                    style={{ paddingLeft: "10px", paddingTop: "10px" }}
                    className="no-results"
                  >
                    Results exceed the permitted limit. Kindly adjust your
                    filters to narrow down the data.
                  </div>
                  {mapResults && mapResults.availableOptions.length > 1 && (
                    <div className="export-button-parent">
                      {mapResults.availableOptions.indexOf("Xlsx") > -1 && (
                        <Button
                          color="secondary"
                          className="export-button"
                          onClick={() => {
                            exportData("xlsx");
                          }}
                        >
                          Export to Excel
                        </Button>
                      )}
                      {mapResults.availableOptions.indexOf("Pdf") > -1 && (
                        <Button
                          color="secondary"
                          className="export-button"
                          onClick={() => {
                            exportData("pdf");
                          }}
                        >
                          Export to PDF
                        </Button>
                      )}
                      {mapResults.availableOptions.indexOf("Csv") > -1 && (
                        <Button
                          color="secondary"
                          className="export-button"
                          onClick={() => {
                            exportData("csv");
                          }}
                        >
                          Export to CSV
                        </Button>
                      )}
                    </div>
                  )}
                </>
              )}
          </div>
        </div>
        {showConfirmPopup && (
          <ConfirmPopup
            title={confirmPopUp.title}
            id={confirmPopUp.id}
            message={confirmPopUp.message}
            confirmAction={confirmPopUp.confirmAction}
            closeAction={confirmPopUp.closeAction}
          ></ConfirmPopup>
        )}
        <div>
          <LoadingOverlay
            show={isLoading || isExportQuery || !selectedCube || initialLoading}
          />
        </div>
      </div>
    );
  },
);
export default QueryResult;
